<template>
  <div class="chemical-engineering">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/marketArea' }">{{ $t('marketArea.breadcrumbMarketArea') }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $t('marketArea.pages.architecture.title') }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="characteristic">
      <div class="characteristic-item"
           @mouseenter="isHover1 = true"
           @mouseleave="isHover1 = false">
        <img :src="isHover1 ? icon1 : icon2">
        <div>{{ $t('marketArea.characteristics.thermalInsulation') }}</div>
      </div>
      <div class="characteristic-item"
           @mouseenter="isHover2 = true"
           @mouseleave="isHover2 = false">
        <img :src="isHover2 ? icon3 : icon4">
        <div>{{ $t('marketArea.characteristics.fireproof') }}</div>
      </div>
    </div>
    <div class="info">
      <div class="info-title">{{ $t('marketArea.pages.architecture.title') }}</div>
      <div class="info-content">{{ $t('marketArea.pages.architecture.content') }}</div>
      <img :src="contentImg">
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      icon1: require('@/assets/images/icon/baowen-bai.png'),
      icon2: require('@/assets/images/icon/baowen-lan.png'),
      icon3: require('@/assets/images/icon/fanghuo-bai.png'),
      icon4: require('@/assets/images/icon/fanghuo-lan.png'),
      contentImg: require('@/assets/images/marketArea/jianzhu.png'),
      isHover1: false,
      isHover2: false,
    }
  }
}
</script>

<style lang="scss" scoped>
.chemical-engineering {
  padding-top: 60px;
  width: 1200px;
  margin: 0 auto;
  .el-breadcrumb {
    padding-bottom: 30px;
  }
  .characteristic {
    display: flex;
    justify-content: space-between;
    .characteristic-item {
      flex: 1;
      margin-right: 24px;
      background: rgba(248, 250, 253, 1);
      text-align: center;
      padding: 58px 0 48px;
      cursor: pointer;
      transition: all .5s;
      &:last-child {
        margin-right: 0;
      }
      div {
        transition: all .5s;
        padding-top: 20px;
        font-size: 24px;
      }
      &:hover {
        background: rgb(28, 100, 215);
        div {
          color: #fff;
        }
      }
    }
  }
  .info {
    padding-top: 100px;
    padding-bottom: 230px;
    .info-title {
      font-weight: 700;
      font-size: 24px;
      line-height: 30px;
      text-align: center;
    }
    .info-content {
      padding-top: 40px;
      font-weight: 400;
      font-size: 18px;
      line-height: 36px;
      color: rgba(43, 50, 71, 0.7);
      text-indent: 2em; 
    }
    img {
      margin-top: 40px;
    }
  }
}
</style>